import React from "react";

const Footer = ({ isDarkMode }) => {
  return (
    <footer className={`p-4 text-center mt-auto ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
      <span className="text-[10px]">
        &copy; 2026 h3RnD3v. All rights reserved.
      </span>
    </footer>
  );
};

export default Footer;